export const SET_COMPANY_SNAPSHOT = "SET_COMPANY_SNAPSHOT";
export const GET_COMPANY_SNAPSHOT = "GET_COMPANY_SNAPSHOT";
